<template>
  <div>
    <el-dialog
      v-model="dialogFormVisible"
      :close-on-click-modal="false"
      :title="title"
      width="80%"
      @close="close"
    >
      <el-form ref="form" label-width="160px" :model="form" :rules="rules">
        <el-form-item v-if="!branchId && !isEdit" label="门店" prop="branchId">
          <el-select v-model="form.branchId" clearable placeholder="请选择门店">
            <el-option
              v-for="item in branchs"
              :key="item.branchId"
              :label="`${item.title}`"
              :value="item.branchId"
            />
          </el-select>
        </el-form-item>
        <el-form-item v-if="!branchId && isEdit" label="公司" prop="branchId">
          {{ branchTitle }}
        </el-form-item>
        <el-form-item label="标题" prop="title">
          <el-input
            v-model.trim="form.title"
            class="fix-width"
            placeholder="请输入标题"
          />
        </el-form-item>
        <el-form-item label="支付宝分账方参数"></el-form-item>
        <el-form-item label="账户" prop="account">
          <el-input
            v-model.trim="form.account"
            class="fix-width"
            placeholder="请输入账户"
          />
        </el-form-item>
        <el-form-item label="类型" prop="typehood">
          <el-radio-group v-model="form.typehood">
            <el-radio :label="2">公司</el-radio>
            <el-radio :label="1">个人</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="名称" prop="name">
          <el-input
            v-model.trim="form.name"
            class="fix-width"
            placeholder="请输入名称"
          />
        </el-form-item>
        <el-form-item label="分账关系" prop="relationType">
          <el-radio-group v-model="form.relationType">
            <el-radio :label="1">门店</el-radio>
            <el-radio :label="2">员工</el-radio>
            <el-radio :label="3">店主</el-radio>
            <el-radio :label="4">合作伙伴</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 微信 -->
        <el-form-item label="微信分账方参数"></el-form-item>
        <el-form-item label="小程序ID" prop="wxAppId">
          <el-input
            v-model.trim="form.wxAppId"
            class="fix-width"
            placeholder="请输入小程序ID"
          />
        </el-form-item>
        <el-form-item label="账户" prop="account1">
          <el-input
            v-model.trim="form.account1"
            class="fix-width"
            placeholder="请输入账户"
          />
        </el-form-item>
        <el-form-item label="类型" prop="typehood1">
          <el-radio-group v-model="form.typehood1">
            <el-radio :label="2">公司</el-radio>
            <el-radio :label="1">个人</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="名称" prop="name1">
          <el-input
            v-model.trim="form.name1"
            class="fix-width"
            placeholder="请输入名称"
          />
        </el-form-item>
        <el-form-item label="分账关系" prop="relationType1">
          <el-radio-group v-model="form.relationType1">
            <el-radio :label="1">门店</el-radio>
            <el-radio :label="2">员工</el-radio>
            <el-radio :label="3">店主</el-radio>
            <el-radio :label="4">合作伙伴</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="form.order" placeholder="排序" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { createReceiver, updateReceiver } from '@/api/splitAccount'
import { getAllBranchs } from '@/api/branch'
export default {
  name: 'SplitAccountEdit',
  emits: ['fetch-data'],
  data() {
    return {
      title: '',
      branchs: [],
      branchTitle: '',
      branchId: '',
      isEdit: false,
      form: {
        branchId: '',
        receiverId: '',
        title: '',
        account: '',
        typehood: '',
        name: '',
        relationType: '',
        wxAppId: '',
        account1: '',
        typehood1: '',
        name1: '',
        relationType1: '',
        order: 1,
      },
      rules: {
        title: [{ required: true, trigger: 'blur', message: '请输入标题' }],
      },
      dialogFormVisible: false,
    }
  },
  methods: {
    async getBranchs() {
      this.branchs = await getAllBranchs()
    },
    showEdit(row) {
      if (row) {
        this.title = '修改分账方'
        this.form = Object.assign(this.form, row.basic)
        this.form.receiverId = row.receiverId
        this.form.title = row.title
        this.form.branchId = row.extra.branchId
        //支付宝
        this.form.account = row.basic.alipay.account
        this.form.typehood = row.basic.alipay.typehood
        this.form.name = row.basic.alipay.name
        this.form.relationType = row.basic.alipay.relationType
        //
        this.form.wxAppId = row.basic.wepay.wxAppId
        this.form.account1 = row.basic.wepay.account
        this.form.typehood1 = row.basic.wepay.typehood
        this.form.name1 = row.basic.wepay.name
        this.form.relationType1 = row.basic.wepay.relationType
      } else {
        this.title = '新增分账方'
      }
      this.dialogFormVisible = true
      this.getBranchs()
    },
    close() {
      this.$refs['form'].resetFields()
      this.form = this.$options.data().form
      this.dialogFormVisible = false
    },
    save() {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          const receiverId = this.form.receiverId
          const data = {}
          const alipay = {
            account:this.form.account,
            typehood: this.form.typehood,
            name: this.form.name,
            relationType:this.form.relationType
          }
          const wepay = {
            wxAppId: this.form.wxAppId,
            account: this.form.account1,
            typehood: this.form.typehood1,
            name: this.form.name1,
            relationType:this.form.relationType1
          }
          data.title = this.form.title
          data.alipay = alipay
          data.wepay = wepay
          data.order = this.form.order
          data.receiverId = receiverId
          data.branchId = this.form.branchId
          this.$baseConfirm(
            `你确定要${receiverId ? '修改' : '新增'}分账方吗`,
            null,
            async () => {
              receiverId ? await updateReceiver(data) : await createReceiver(data)
              this.$baseMessage(
                `${receiverId ? '修改' : '新增'}分账方成功`,
                'success',
                false,
                'vab-hey-message-success'
              )
              this.$emit('fetch-data')
              this.close()
            }
          )
        } else {
          return false
        }
      })
    },
    mounted() {
      const me = storejs.get('me')
      this.branchId = me.extra.branchId || ''
    },
  },
}
</script>

<style lang="scss" scoped>
@mixin size($scale: 1, $type: small) {
  @if $type == large {
    width: 343px * $scale;
  } @else {
    width: 167px * $scale;
  }
  height: 167px * $scale;
}
.avatar-uploader {
  .avatar {
    border-radius: 6px;
    transition: all 0.3s ease-in-out;
    @include size;
  }
}
.avatar-uploader-icon {
  border: 1px dashed #c0ccda;
  background-color: #fbfdff;
  border-radius: 6px;
  font-size: 28px;
  color: #8c939d;
  width: 148px;
  height: 148px;
  line-height: 148px;
  text-align: center;
}
.tags {
  margin-bottom: 5px;
}
.tags + .tags,
.tags + .button-new-tag {
  margin-left: 10px;
}
.button-new-tag {
  // margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
.disabled .el-upload--picture-card {
  display: none;
}
.fix-width {
  width: 500px;
}
.mb-10 {
  margin-bottom: 10px;
}
.tips {
  color: #aaaaaa;
  margin-left: 50px;
}
</style>
